type InvoicePdfAttachError = {
  externalId: string;
  error?: string;
};

type InvoicePdfAttachErrorNotice =
  | {
      type: "auth";
      message: string;
    }
  | {
      type: "partial";
      message: string;
    };

const ACCOUNTING_AUTH_ERROR_SNIPPETS = [
  "authentication failed",
  "authenticationunsuccessful",
  "please reconnect your accounting software",
];

export const INVOICE_PDF_ACCOUNTING_RECONNECT_MESSAGE =
  "Accounting software connection expired. Reconnect under Files & Integrations.";

export const isInvoicePdfAccountingAuthError = (
  message: string | null | undefined,
): boolean => {
  const normalized = (message ?? "").toLowerCase();
  return ACCOUNTING_AUTH_ERROR_SNIPPETS.some((snippet) =>
    normalized.includes(snippet),
  );
};

export const getInvoicePdfAttachErrorNotice = (
  errors: InvoicePdfAttachError[],
): InvoicePdfAttachErrorNotice | null => {
  if (errors.length === 0) {
    return null;
  }
  if (errors.some((entry) => isInvoicePdfAccountingAuthError(entry.error))) {
    return {
      type: "auth",
      message: INVOICE_PDF_ACCOUNTING_RECONNECT_MESSAGE,
    };
  }
  const failedIds = errors.map((entry) => entry.externalId).join(", ");
  return {
    type: "partial",
    message: `Could not attach invoice PDF(s): ${failedIds}. Use Attach to retry.`,
  };
};
